<template>
  <div class="loader_gif">
    <div
      class="loader_spinner"
      :class="{ dark: current_theme === 'dark' }"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      current_theme: ["theme_module/current_theme"],
    }),
  },
};
</script>

<style lang="scss" scoped>
.loader_gif {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: transparent;
}

.loader_spinner {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  border: 6px solid rgba(255, 255, 255, 0.15);
  border-top-color: var(--main);
  animation: spin 1s linear infinite;

  &.dark {
    border-top-color: var(--main);
    border-color: rgba(0, 0, 0, 0.1);
  }
}

.loader_label {
  font-size: 14px;
  letter-spacing: 1px;
  color: var(--mainText);
  text-transform: uppercase;
  font-weight: 600;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

